import React from 'react';
import {useFormikContext} from 'formik';

import {useMediaQuery} from 'src/hooks/useMediaQuery';

import FormikDropdown from 'src/components/formik-dropdown';
import FormikTextArea from 'src/components/formik-text-area';
import FormikTextInput from 'src/components/inputs/formik-text-input';
import TextButton from 'src/components/TextButton';
import Label from 'shared/components/label';
import {ActivityForm} from './activities-form-wrapper';

interface Props {
  _id: string;
  handleRemove: (index: number) => void;
}

const LeadershipPositions = ({_id, handleRemove}: Props) => {
  const mq = useMediaQuery();
  const formik = useFormikContext<ActivityForm>();

  const formattedSchoolYears = formik.values.schoolYears.map((year) => ({
    value: year,
    text: year,
  }));

  return formik.values.leadershipPositions.map((_, i) => (
    <div className="activity-leadership-positions" key={`leadership-position-${_id}-${i}`}>
      <div className="portfolio-sections side-by-side">
        <Label noTopPadding required>
          Position Title
          <FormikTextInput
            name={`leadershipPositions.${i}.title`}
            placeholder="e.g. Captain, President"
            required
          />
        </Label>
        <Label noTopPadding={mq.SM_AND_UP} required>
          Year (Choose one)
          <FormikDropdown
            name={`leadershipPositions.${i}.schoolYear`}
            options={formattedSchoolYears}
            required
          />
        </Label>
      </div>

      <Label>
        Description (Optional)
        <FormikTextArea
          name={`leadershipPositions.${i}.description`}
          placeholder="Description..."
        />
      </Label>

      <TextButton
        type="button"
        onClick={() => handleRemove(i)}
        color="dark-gray"
        buttonName="portfolio activities leadership-positions remove"
      >
        Remove
      </TextButton>
    </div>
  ));
};

export default LeadershipPositions;
